const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            avaiable:           'Disponível até',
            abstract:           'Resumo',
            cancel:             'Cancelar',
            close:              'Fechar',
            content:            'Conteúdo',
            content_add:        'Adicionar bloco',
            choose_category:    'Pressione no enter para escolher a categoria',
            choose_option:      'Escolher',
            content_edit:       'Editar produto',
            content_new:        'Novo produto',
            content_list:       'Lista de produtos',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            draft:              'Rascunho',
            doc_choose:         'Escolher PDF',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            file_attach:        'Attach file',
            field_reference:    'Referência',
            field_name:         'Nome',
            field_brand:        'Marca',
            field_features:     'Características',
            field_quantity_units: 'Quantidade',
            field_quantity_units_placeholder: 'Introduza a quantidade',
            field_quantity_minimum: 'Quantidade minima por venda',
            field_quantity_minimum_placeholder: 'Introduza a quantidade minima por venda',
            field_quantity_stock: 'Stock disponível online',
            field_quantity_stock_placeholder: 'Intoduza o stock disponível online',
            field_quantity_low_stock_warning: 'Limite para aviso',
            field_quantity_low_stock_warning_placeholder: 'Introduza o limite para aviso',
            field_quantity_low_stock_email_warning: 'Enviar email de aviso',
            field_quantity_label_in_stock: 'Label com Stock',
            field_quantity_label_in_stock_placeholder:'Inserir label com Stock',
            field_quantity_label_out_stock: 'Label sem Stock',
            field_quantity_label_out_stock_placeholder:'Inserir label sem Stock',
            field_quantity_stock_out: 'Comportamento sem Stock',
            field_quantity_stock_out_allow: 'Permitir encomendas',
            field_quantity_stock_out_deny: 'Não permitir encomendas',
            field_price:   'Preço',
            field_price_placeholder:  'Inserir preço',
            field_stock:   'Stock',
            field_stock_placeholder:  'Inserir stock',
            field_price_base:   'Preço base',
            field_price_base_placeholder:  'Inserir preço base',
            field_stock_base:   'Stock base',
            field_stock_base_placeholder:  'Inserir stock base',
            field_taxe_base:     'Taxa base',
            field_width:        'Largura',
            field_width_placeholder:  'Inserir largura',
            field_height:       'Altura',
            field_height_placeholder:  'Inserir altura',
            field_depth:        'Comprimento',
            field_depth_placeholder:  'Inserir comprimento',
            field_weight:       'Peso',
            field_weight_placeholder:  'Inserir peso',
            field_delivery:     'Tipo de entrega',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            galleries:          'Galerias',
            gallery:            'Galeria',
            gallery_add:        'Adicionar bloco',
            gallery_edit:       'Editar galeria',
            gallery_new:        'Novo galeria',
            gallery_list:       'Lista de galerias',
            id:                 'ID',
            layout:             'Tipo',
            multimedia:         'Multimédia',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            image:              'Imagem de destaque',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            store:              'Loja Online',
            store_product:      'Produto',
            store_product_edit: 'Editar produto',
            store_product_new:  'Novo produto',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            principal:          'Principal',
            published:          'Publicado',
            reference:          'Referência',
            reference_placeholder:  'Introduza a referência',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            tab_geral:          'Geral',
            tab_qtd:            'Quantidade',
            tab_combinations:   'Combinações',
            tab_price:          'Preço',
            tab_shipping:       'Portes e Embalamento',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_state:        'Estado',
            table_actions:      'Acções',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            save:               'Salvar',      
            youtube_choose:      'Youtube',             
        },
    'en':
        {
            add_new:            'Add new',
            avaiable:           'Avaiable until',
            abstract:           'Abstract',
            cancel:             'Cancel',
            close:              'Close',
            content:            'Content',
            content_add:        'Add block',
            choose_category:    'Press enter to add new tag',
            choose_option:      'Choose',
            content_edit:       'Edit product',
            content_new:        'New product',
            content_list:       'Product list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            draft:              'Draft',
            doc_choose:         'Choose PDF',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            file_attach:        'Attach file',
            field_reference:    'Referência',
            field_name:         'Nome',
            field_brand:        'Brand',
            field_features:     'Features',
            field_quantity_units: 'Quantidade',
            field_quantity_units_placeholder: 'Introduza a quantidade',
            field_quantity_minimum: 'Quantidade minima por venda',
            field_quantity_minimum_placeholder: 'Introduza a quantidade minima por venda',
            field_quantity_stock: 'Stock disponível online',
            field_quantity_stock_placeholder: 'Intoduza o stock disponível online',
            field_quantity_low_stock_warning: 'Limite para aviso',
            field_quantity_low_stock_warning_placeholder: 'Introduza o limite para aviso',
            field_quantity_low_stock_email_warning: 'Enviar email de aviso',
            field_quantity_label_in_stock: 'Label com Stock',
            field_quantity_label_in_stock_placeholder:'Inserir label com Stock',
            field_quantity_label_out_stock: 'Label sem Stock',
            field_quantity_label_out_stock_placeholder:'Inserir label sem Stock',
            field_quantity_stock_out: 'Comportamento sem Stock',
            field_quantity_stock_out_allow: 'Permitir encomendas',
            field_quantity_stock_out_deny: 'Não permitir encomendas',
            field_price:   'Preço',
            field_price_placeholder:  'Inserir preço',
            field_stock:   'Stock',
            field_stock_placeholder:  'Inserir stock',
            field_price_base:   'Base price',
            field_price_base_placeholder:  'Insert base price',
            field_stock_base:   'Stock base',
            field_stock_base_placeholder:  'Inserir stock base',
            field_taxe_base:     'Taxa base',
            field_width:        'Largura',
            field_width_placeholder:  'Inserir largura',
            field_height:       'Altura',
            field_height_placeholder:  'Inserir altura',
            field_depth:        'Comprimento',
            field_depth_placeholder:  'Inserir comprimento',
            field_weight:       'Peso',
            field_weight_placeholder:  'Inserir peso',
            field_delivery:      'Delivery type',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            galleries:          'Galleries',
            gallery:            'Galleria',
            gallery_add:        'Add block',
            gallery_edit:       'Edit gallery',
            gallery_new:        'New gallery',
            gallery_list:       'Galeries list',
            id:                 'ID',
            layout:             'Type',
            multimedia:         'Multimedia',
            name:               'Name',
            name_placeholder:   'Insert the name',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            store:              'Online Store',
            store_product:      'Product',
            store_product_edit: 'Edit product',
            store_product_new:  'New product',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            principal:          'Principal',
            published:          'Publicado',
            reference:          'Reference',
            reference_placeholder:  'Insert the reference',
            remove:             'Remove',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            tab_geral:          'General',
            tab_qtd:            'Quantity',
            tab_combinations:   'Combinations',
            tab_price:          'Price',
            tab_shipping:       'Portes e Embalamento',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_state:        'State',
            table_actions:      'Actions',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            save:               'Save',
            youtube_choose:      'Youtube', 
        }
}

module.exports = {
    language
};